import { FiUsers, FiActivity, FiTrendingUp, FiCreditCard } from "react-icons/fi";

const cards = (dashboard) => [
    { title: "Visitors", value: dashboard.total_visitors, icon: <FiUsers size={18} />, accent: "sky" },
    { title: "Sessions", value: dashboard.total_sessions, icon: <FiActivity size={18} />, accent: "violet" },
    { title: "Conversion", value: `${dashboard.conversion_rate}%`, icon: <FiTrendingUp size={18} />, accent: "emerald" },
    { title: "Payments", value: dashboard.payment_success, icon: <FiCreditCard size={18} />, accent: "amber" },
];

const styles = {
    sky: { bg: "bg-sky-50", ring: "ring-sky-100", icon: "bg-sky-500", dot: "bg-sky-500" },
    violet: { bg: "bg-violet-50", ring: "ring-violet-100", icon: "bg-violet-500", dot: "bg-violet-500" },
    emerald: { bg: "bg-emerald-50", ring: "ring-emerald-100", icon: "bg-emerald-500", dot: "bg-emerald-500" },
    amber: { bg: "bg-amber-50", ring: "ring-amber-100", icon: "bg-amber-500", dot: "bg-amber-500" },
};

const ExecutiveKPIs = ({ dashboard }) => {
    return (
        <div className="rounded-2xl border border-slate-200 bg-gradient-to-br from-slate-50 via-white to-indigo-50/40 p-4">
            <div className="grid grid-cols-2 gap-3 xl:grid-cols-4">
                {cards(dashboard).map((card) => {
                    const s = styles[card.accent];
                    return (
                        <div
                            key={card.title}
                            className={`group relative overflow-hidden rounded-xl ${s.bg} ring-1 ${s.ring} p-4 transition-transform duration-200 hover:-translate-y-0.5`}
                        >
                            <div className="flex items-center justify-between">
                                <div className={`flex h-9 w-9 items-center justify-center rounded-lg ${s.icon} text-white shadow-sm`}>
                                    {card.icon}
                                </div>
                                <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
                            </div>

                            <p className="mt-3 text-xs font-medium uppercase tracking-wide text-slate-500">
                                {card.title}
                            </p>
                            <h2 className="mt-1 text-2xl font-bold tabular-nums text-slate-900">
                                {card.value}
                            </h2>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ExecutiveKPIs;